import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, LabelList, ResponsiveContainer, Rectangle } from 'recharts';
import { chartContainer } from './Chart.module.css';

import medalhaOuro from './images/ouro.svg';
import medalhaPrata from './images/prata.svg';
import medalhaBronze from './images/bronze.svg';
import medalhaParticipacao from './images/participacao.svg';
import Avatar from './Avatar';
import MediaChart from './MediaChart';

const ChartRanking = ({
    media = { name: 'Média da Equipe', value: 100 }, 
    barHeight=100, 
    chartHeight=100,
    ...props
}) => {
    const [containerWidth, setContainerWidth] = useState(600);
    const [containerHeight, setContainerHeight] = useState(300);



    const icon = [
        medalhaOuro,
        medalhaPrata,
        medalhaBronze,
        medalhaParticipacao
    ]

    const dataExample = [
        { name: 'Categoria A', value: 100, endIcon: <Avatar /> },
        { name: 'Categoria B', value: 90, endIcon: <Avatar /> },
        { name: 'Categoria C', value: 80, endIcon: <Avatar /> },
        { name: 'Categoria D', value: 70, endIcon: <Avatar /> },
        { name: 'Categoria E', value: 60, endIcon: <Avatar /> },
        { name: 'Categoria F', value: 50, endIcon: <Avatar /> },
        { name: 'Categoria G', value: 40, endIcon: <Avatar /> },
        { name: 'Categoria H', value: 30, endIcon: <Avatar /> },
        { name: 'Categoria I', value: 20, endIcon: <Avatar /> },
        { name: 'Categoria J', value: 10, endIcon: <Avatar /> },
    ];

    const data = props?.demo ? dataExample : (props.data || [])
    const dataLength = data?.length < 8 ? 8 : data?.length


    let iconSize = ((containerHeight / dataLength) - 30) > 30 ? ((containerHeight / dataLength) - 30) : 30 || 30;
    let AvatarSize = ((containerHeight / dataLength) - 20) > 40 ? ((containerHeight / dataLength) - 20) : 40 || 40;

    if (props?.percentageHeight) {
        AvatarSize = (AvatarSize * (props?.percentageHeight / 100))
        iconSize = (iconSize * (props?.percentageHeight / 100))
        // props?.percentageHeight ? (AvatarSize * (props?.percentageHeight / 100))
    }

    const barheight = (containerHeight / dataLength) < 50 ? 50 : (containerHeight / dataLength)

    useEffect(() => {
        const handleResize = () => {
            const container = document.querySelector(`.${chartContainer}`);

            // console.log('offsetWidth', container.offsetWidth)
            // console.log('offsetHeight', container.offsetHeight)

            if (container) {
                setContainerWidth(container.offsetWidth);
                setContainerHeight(container.offsetHeight);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const renderCustomBarLabel = ({ x, y, width, height, index, value }) => {
        const startIcon = value === 100 ? icon[0] : icon[index] ? icon[index] : medalhaParticipacao;
        const endIcon = data[index].endIcon;

        const startX = x - iconSize - 5;
        let endX = x + width + 5;
        const iconY = y + (height / 2) - (iconSize / 2);
        const avatarY = y + (height / 2) - (AvatarSize / 2);

        if (endX + iconSize > containerWidth - 40) {
            endX = containerWidth - AvatarSize - 40;
        }

        return (
            <g>
                <image
                    x={startX}
                    y={iconY}
                    width={(index === 0 ? iconSize + 10 : index === 1 ? iconSize + 5 : index === 2 ? iconSize + 3 : iconSize)}
                    height={(index === 0 ? iconSize + 10 : index === 1 ? iconSize + 5 : index === 2 ? iconSize + 3 : iconSize)}
                    xlinkHref={startIcon}
                />
                {/* Renderiza o componente endIcon */}
                <foreignObject
                    x={endX}
                    y={avatarY}
                    width={AvatarSize}
                    height={AvatarSize}
                >
                    {endIcon}
                </foreignObject>
            </g>
        );
    };

    const renderCustomLabel = (props) => {
        const { x, y, width, height, value } = props;
        const textColor = 'white'//value > 41 ? 'white' : '#000';
        return (
            <text x={x + width / 2} y={y + height / 2} dy={5} fill={textColor} textAnchor="middle" font-weight="bold" font-size="smaller">
                {value}
            </text>
        );
    };


    const renderCustomLabelMedia = (props) => {
        const { x, y, width, height, value } = props;
        const textColor = 'white'//value > 41 ? 'white' : '#000';
        return (
            <text x={x + width / 2} y={y + height / 2} dy={5} fill={textColor} textAnchor="middle" font-weight="bold">
                Média da equipe: {value.toFixed(1)}
            </text>
        );
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', borderRadius: 5, padding: '10px', border: '1px solid #ccc' }}>
                    <p className="label">{label}</p>
                    <p className="value">{`Pontuação: ${payload[0].value}`}</p>
                    {/* Customize further as needed */}
                </div>
            );
        }

        return null;
    };


    const getColor = (value) => {
        let red, green;
        const normalizedValue = Math.max(0, Math.min(100, value)) / 100;
        // console.log('normalizedValue: ', normalizedValue)
        // if (normalizedValue < 0.5) {
        //     const ratio = normalizedValue / 0.5;
        //     red = 255;
        //     green = 165 * (ratio);
        // } else {
        //     const ratio = (normalizedValue - 0.5) / 0.5;
        //     red = 255 * (1 - (ratio - 0.3));
        //     green = 165;
        // }
        switch (true) {
            case (normalizedValue <= 1 && normalizedValue > 0.8):
                red = 0
                green = 160
                break;
            case (normalizedValue <= 0.8 && normalizedValue > 0.6):
                red = 255
                green = 160
                break;
            case (normalizedValue <= 0.6 && normalizedValue > 0.4):
                red = 255
                green = 120
                break;
            case (normalizedValue <= 0.4 && normalizedValue > 0.2):
                red = 255
                green = 80
                break;
            case (normalizedValue <= 0.2):
                red = 255
                green = 0
                break;

            default:
                red = 0
                green = 160
                break;
        }

        return `rgb(${red}, ${green}, 0)`;
    };

    // console.log(data)

    const orderedData = data?.sort((a, b) => {
        if (b.value < a.value) {
            return -1;
        }
        if (b.value > a.value) {
            return 1;
        }

        // names must be equal
        return 0;
    })


    // Média da equipe object
    // const media = [
    //     {
    //         name: 'Média da Equipe',
    //         value: props.media,
    //     }
    // ];

    // console.log('barheight', parseInt(window?.innerHeight / dataLength))

    return (
        <div
            className={chartContainer}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: props?.percentageHeight ? ((window.innerHeight / 100) * props?.percentageHeight) : '100%',
                zIndex: 5
            }}
        >
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={orderedData}
                    layout="vertical"
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                    <XAxis type="number" tickFormatter={() => ""} stroke="none" />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        dataKey="name"
                        type="category"
                        tickFormatter={(value) => ''}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar
                        radius={[0, 5, 5, 0]}
                        dataKey="value"
                        // barSize={(containerHeight / data.length) || 50}
                        barSize={barheight}
                        label={renderCustomBarLabel}
                    >
                        {orderedData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={getColor(entry.value)} />
                        ))}
                        <LabelList dataKey="value" content={renderCustomLabel} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ChartRanking;
